import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getUser, getClDomain, getRolName } from '../../utils/Common';
// contexts
import AuthContext from '../../contexts/auth';
import SidebarContext from '../../contexts/sidebar';
// icons
import * as BsIcons from 'react-icons/bs';
import './index.css';
// sidebar info
import Submenu from './Submenu';
import Options from './Options/indexRoles';

const Sidebar = () => {
	const userContext = useContext(AuthContext);
	const sidebarContext = useContext(SidebarContext);
	const [SidebarData,] = useState(Options(userContext.user));
	const user = getUser();
	const handleName = () => {
		if (userContext.user?.NombreSimple.indexOf(' ') > -1) return `${userContext.user?.NombreSimple.split(' ')[0]} ${userContext.user?.ApellidoSimple}`;
		else return `${userContext.user?.NombreSimple} ${userContext.user?.ApellidoSimple}`;
	}

	const handlePerfilOption = () => {
		sidebarContext.handleChangeCurrentPage('Perfil');

		if (sidebarContext.isMobile) sidebarContext.closeSidebar();
	}

	return (
		<div 
			className={ "sidebar" + (sidebarContext.sidebarOpen ? "-open" : "-close") }
			style={ getClDomain() !== 'cotel.myboxit.com' ? { top: '22px' } : { top: '0px' } }>
			<div className="logo-section d-flex justify-content-between pt-2">
				<div className="logo-boxit pt-6" style={{
					backgroundImage: sidebarContext.sidebarOpen ? `url(/img/logo-correos.png)` : "url(/img/logo-correos-b.png)",
					width: sidebarContext.sidebarOpen ? 125 : 55,
					height: sidebarContext.sidebarOpen ? 125 : 55
				 }} />
				{ sidebarContext.isMobile && 
					<div className="close-icon mt-1 mr-3" onClick={ () => sidebarContext.closeSidebar() } >
						<BsIcons.BsX className="btn-close" size={ 30 }/>
					</div>
				}
			</div>

			<div className="usersection d-flex flex-column mb-3 pb-4">
				<div className="usersection-icon mt-4 mx-auto">
					<Link to="/dashboard/profile/" className="user-icon" onClick={ () => handlePerfilOption() }>
						<BsIcons.BsPersonCircle className={ 'user-icon ' + (sidebarContext.currentPage === 'Perfil' ? 'boxit-fucsia' : 'boxit-gray') } size={ sidebarContext.sidebarOpen ? 65 : 45 } />
					</Link>
				</div>

				<div className={ "text-left mt-3 ml-4 userdata" + (!sidebarContext.isMobile && (sidebarContext.sidebarOpen ? '' : '-close')) }>
					
					{ user.roleId >= 2 && user.roleId < 6 &&
						 (
					<div className="mb-2">
						<h6 className="sidebar-title mb-0">{user.roleId <= 3 ?"Estafeta": "Provincia"}:</h6>
						<span className="sidebar-data">{ user.roleId <= 3  ? userContext.user?.NombreEstafeta : userContext.user?.NombreProvincia }</span>
					</div>
						)
					}
					{ user.roleId  < 3 &&
						 (
					<div className="mb-2">
						<h6 className="sidebar-title mb-0">{"Caja"}:</h6>
						<span className="sidebar-data">{ userContext.user?.NombreCaja ? userContext.user?.NombreCaja : '' }</span>
					</div>
						)
					}
					
					<div>
						<h6 className="sidebar-title mb-0">Nombre:</h6>
						<span className="sidebar-data">{ userContext.user?.NombreSimple ? handleName() : 'Usuario' }</span>
					</div>
					{ user.roleId &&
					<div className="mt-2">
						<h6 className="sidebar-title mb-0">Rol:</h6>
						<span className="sidebar-data">{ user.roleId ? getRolName(user.roleId): 'Usuario'  }</span>
					</div>
					}	
				</div>
			</div>

			<ul className="sidebarWrap d-flex flex-column">
			{
				SidebarData && SidebarData.map((item, index) => {
					return <li key={index} className="relative">
								<Submenu item={item} />
							</li>
				})
			}
			</ul>
		</div>
	);
}

export default Sidebar;